import BlamePreferences from '/builds/gitlab/gitlab-ee/app/assets/javascripts/blame/preferences/blame_preferences.vue?vue3';
import BlameLegend from '~/blame/blame_legend.vue';
export default {
    name: 'BlameHeader',
    components: {
        BlamePreferences,
        BlameLegend
    },
    inject: [
        'hasRevsFile'
    ],
    data () {
        return {
            showAgeIndicator: false
        };
    },
    methods: {
        onToggleAgeIndicator (value) {
            this.showAgeIndicator = value;
        }
    }
};
